//   const { isAuthenticated, companyId, UserId, permissions, token, logout, roleName } = useAuth();
import React, { Fragment, useState, useContext, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData, updateData } from '../../apiService';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import Button from '@mui/material/Button';
import { Card, CardContent, Modal } from '@mui/material';
import CopyrightIcon from '@mui/icons-material/Copyright';

function Home() {   // const history = useHistory();

    /* API Call Post Method */
    const { isAuthenticated, companyId, UserId, logout, token } = useAuth();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
    }, [isAuthenticated, companyId, UserId, token, logout, id]);

    
    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
            <style>
                {`
        /* Hide scrollbar for Chrome, Safari, and Opera */
        .container::-webkit-scrollbar {
          width: 0.1em;
        }

        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }

        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
            </style>
            <div className="flex flex-wrap justify-between">


            </div>
            
        </div >
    );

};

export default Home;

